export default "__VITE_ASSET__uZg_dnp___"